import parseCustomHTML from "../helpers/parseCustomHTML"

export default function CustomHTML({html}: {html: string}) {
    return (
        <span
            dangerouslySetInnerHTML={{ __html: parseCustomHTML(html)}}
        />
    )
}
